import { render, staticRenderFns } from "./BatchSetCardDialog.vue?vue&type=template&id=bc8c7fa8&"
import script from "./BatchSetCardDialog.vue?vue&type=script&lang=js&"
export * from "./BatchSetCardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports